<template>
  <div class="card-title-warp" @click="onClickCardTitleMore()">
    <van-row type="flex" justify="space-between" style="align-items: center">
      <van-col class="card-title-name">
        <span>{{ title }}</span>
        <span v-if="reviewTime" class="review-time">{{ time }}</span>
      </van-col>
      <van-col v-if="isMore" class="card-title-more"
        >更多<i class="iconfont ic-arrow-right-o"
      /></van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: 'CardTitle',
  components: {},
  props: {
    title: {
      type: String, // 标题
      default: '标题'
    },
    reviewTime: {
      type: Number, // 时间
      default: () => null
    },
    isMore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    time() {
      return this.$moment(this.reviewTime * 1000).format('YYYY-MM-DD');
    }
  },
  methods: {
    onClickCardTitleMore() {
      this.$emit('onClickMainTitleMore');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../common/css/common-mixin";
.card-title {
  &-warp {
    height: rpx(45);
    line-height: rpx(45);
  }
  &-name {
    height: rpx(45);
    display: flex;
    font-size: rpx(32);
    color: rgba(0, 0, 0, 0.9);
    font-weight: bold;
    .review-time {
      height: rpx(28);
      padding: 0 rpx(6);
      margin: rpx(9) 0 0 rpx(8);
      font-size: rpx(20);
      color: #1a66ff;
      line-height: rpx(28);
      font-weight: normal;
      border-radius: rpx(4);
      background: rgba(26, 102, 255, 0.04);
    }
  }
  &-more {
    height: rpx(45);
    font-size: rpx(24);
    color: rgba(0, 0, 0, 0.6);
    font-weight: normal;

    i {
      font-size: rpx(24);
      color: rgba(0, 0, 0, 0.4);
      margin-left: rpx(4);
      vertical-align: baseline;
    }
  }
}
</style>
